import React, { useEffect, useRef, useState } from "react";
const PortfolioPieChart = ({ inspectiondatalist }) => {
  const chartRef = useRef();
  const [chartSize, setChartSize] = useState({ width: 0, height: 0 });

  const totalCount =
    inspectiondatalist?.data?.reduce((sum, item) => sum + item.count, 0) || 0;

  const data =
    inspectiondatalist?.data?.map((item) => ({
      originator: item.name,
      count: item.count,
      percentage:
        totalCount > 0 ? ((item.count / totalCount) * 100).toFixed(1) : 0,
    })) || [];

  const colorPalette = {
    Field: "#6366F1",
    "Shop 1": "#06B6D4",
    "Shop 2": "#10B981",
  };

  useEffect(() => {
    const updateChartSize = () => {
      if (chartRef.current) {
        const width = chartRef.current.offsetWidth;
        const height = chartRef.current.offsetHeight;
        setChartSize({ width, height });
      }
    };
    updateChartSize();
    window.addEventListener("resize", updateChartSize);

    return () => {
      window.removeEventListener("resize", updateChartSize);
    };
  }, []);

  useEffect(() => {
    const svgNS = "http://www.w3.org/2000/svg";
    const chartElement = chartRef.current;

    while (chartElement.firstChild) {
      chartElement.removeChild(chartElement.firstChild);
    }

    const { width, height } = chartSize;
    const radius = Math.min(width, height) / 2 - 10;

    const svg = document.createElementNS(svgNS, "svg");
    svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
    svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
    svg.style.width = "100%";
    svg.style.height = "100%";

    const g = document.createElementNS(svgNS, "g");
    g.setAttribute("transform", `translate(${width / 2}, ${height / 2})`);
    svg.appendChild(g);

    const nonZeroData = data.filter((d) => d.count > 0);
    const totalNonZeroCount = nonZeroData.reduce((sum, d) => sum + d.count, 0);

    if (totalNonZeroCount > 0) {
      let startAngle = 0;
      nonZeroData.forEach((d) => {
        const sliceAngle = (d.count / totalNonZeroCount) * Math.PI * 2;
        const endAngle = startAngle + sliceAngle;

        const x1 = Math.cos(startAngle) * radius;
        const y1 = Math.sin(startAngle) * radius;
        const x2 = Math.cos(endAngle) * radius;
        const y2 = Math.sin(endAngle) * radius;

        const largeArc = sliceAngle > Math.PI ? 1 : 0;

        const pathData = [
          `M0,0`,
          `L${x1},${y1}`,
          `A${radius},${radius} 0 ${largeArc},1 ${x2},${y2}`,
          `Z`,
        ].join(" ");

        const path = document.createElementNS(svgNS, "path");
        const fillColor = colorPalette[d.originator] || "#8B5CF6";
        path.setAttribute("d", pathData);
        path.setAttribute("fill", fillColor);
        g.appendChild(path);

        startAngle = endAngle;
      });
    }
    const legend = document.createElement("div");
    legend.style.position = "absolute";
    legend.style.top = 0;
    legend.style.right = 0;
    legend.style.fontSize = "12px";
    data.forEach((d) => {
      const legendItem = document.createElement("div");
      legendItem.style.display = "flex";
      legendItem.style.alignItems = "center";
      legendItem.style.marginBottom = "4px";
      legendItem.style.opacity = d.count === 0 ? "0.5" : "1";

      const colorBox = document.createElement("div");
      colorBox.style.width = "12px";
      colorBox.style.height = "12px";
      const fillColor = colorPalette[d.originator] || "#8B5CF6";

      colorBox.style.backgroundColor = fillColor;
      colorBox.style.marginRight = "6px";

      const text = document.createElement("span");
      text.textContent = `${d.originator} - ${d.percentage}%`;

      legendItem.appendChild(colorBox);
      legendItem.appendChild(text);
      legend.appendChild(legendItem);
    });

    chartElement.appendChild(svg);
    chartElement.appendChild(legend);
  }, [chartSize, data]);

  return (
    <div
      ref={chartRef}
      style={{
        position: "relative",
        width: "100%",
        height: "200px",
      }}
    ></div>
  );
};

export default PortfolioPieChart;
